import { useRef, useEffect, useCallback } from "react";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";

const DRAWER_ANIMATION_DURATION = 300;

export const useDrawerNavigation = () => {
  const switchTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const resetTimerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      clearTimeout(switchTimerRef.current);
      clearTimeout(resetTimerRef.current);
    };
  }, []);

  const switchToDrawer = useCallback((targetOverlayId: string) => {
    overlayEventEmitter.emit("close", {});
    switchTimerRef.current = setTimeout(() => {
      overlayEventEmitter.emit("open", { overlayId: targetOverlayId });
    }, DRAWER_ANIMATION_DURATION);
  }, []);

  const resetStateAfterClose = useCallback((resetFn: () => void) => {
    resetTimerRef.current = setTimeout(() => {
      resetFn();
    }, DRAWER_ANIMATION_DURATION);
  }, []);

  return { switchToDrawer, resetStateAfterClose };
};
